import styled from 'styled-components';
import PageTop from '../components/pageTop/PageTop';
import Menu from '../components/menu/Menu';
import { useEffect, useState } from 'react';
import MyPageFilter from './MypageFilter';
import Footer from '../components/footer/Footer';
import RecentItem from './RecentItem';
import EditMyInfo from './editMyInfo/EditMyInfo';
import ScrollToTopButton from '../components/ScrollToTopButton';

const MyPage = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const [currentTab, setCurrentTab] = useState('관심물건');

  const tabItems = [
    {
      name: '관심물건',
      value: '관심물건',
      onclick: () => {
        sessionStorage.setItem('mypageTab', 'interest');
        setCurrentTab('관심물건');
      },
    },
    {
      name: '최근 열람 물건',
      value: '최근 열람 물건',
      onclick: () => {
        sessionStorage.setItem('mypageTab', 'recent');
        setCurrentTab('최근 열람 물건');
      },
    },
    {
      name: '내 정보 수정',
      value: '내 정보 수정',
      onclick: () => {
        sessionStorage.setItem('mypageTab', 'myinfo');
        setCurrentTab('내 정보 수정');
      },
    },
  ];

  const mypageTab = sessionStorage.getItem('mypageTab');

  useEffect(() => {
    if (mypageTab && mypageTab === 'interest') {
      setCurrentTab('관심물건');
    }

    if (mypageTab && mypageTab === 'recent') {
      setCurrentTab('최근 열람 물건');
    }

    if (mypageTab && mypageTab === 'myinfo') {
      setCurrentTab('내 정보 수정');
    }
  }, [mypageTab]);

  const renderContent = () => {
    if (currentTab === '관심물건') {
      return <MyPageFilter />;
    }
    if (currentTab === '최근 열람 물건') {
      return <RecentItem />;
    } else {
      return <EditMyInfo />;
    }
  };

  return (
    <Container>
      <ScrollToTopButton></ScrollToTopButton>
      <PageTop text="마이페이지" setOpenMenu={setOpenMenu} />
      <TabBox>
        <TabInner>
          {tabItems.map((tab, index) => (
            <Tab
              key={index}
              active={currentTab === tab.value}
              onClick={tab.onclick}
            >
              {tab.name}
            </Tab>
          ))}
        </TabInner>
      </TabBox>
      {renderContent()}
      {openMenu && <Menu page="mypage" setOpenMenu={setOpenMenu} />}
      <Footer />
    </Container>
  );
};
export default MyPage;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
  font-family: Spoqa Han Sans Neo;
`;

const TabBox = styled.div`
  width: 100%;
  border-bottom: 1px solid #e1e2e4;
  position: sticky;
  top: 56px;
  max-width: inherit;
  background-color: #fff;
  z-index: 1000;
`;

const TabInner = styled.div`
  width: 100%;
  padding: 0 16px;
  display: flex;
  flex-direction: row;
`;
const Tab = styled.div<{ active?: boolean }>`
  flex: 1;
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: ${(props) => (props.active ? '#000' : '#a0a0a0')};
  border-bottom: 2px solid ${(props) => (props.active ? '#000' : 'transparent')};
  cursor: pointer;
`;
